import { Injectable } from '@angular/core';

import { BetslipConfig } from '@frontend/sports/common/client-config-data-access';

import { BetslipType } from '../../../core/betslip-type';
import { BetslipPick } from '../../../core/picks/betslip-pick';
import { isStartingPriceSelected, isXCastPick } from '../../picks/services/betslip-pick-helpers';
import { ICalculatorInput } from '../models';
import { ComboSlipType } from '../slip-type';
import BaseInputBuilder, { BetslipStateInput } from './base-input-builder';
import ComboBetInputBuilder from './combo-bet-input-builder';
import SingleBetInputBuilder from './single-bet-input-builder';

@Injectable()
export default class UpsellInputBuilder extends BaseInputBuilder {
    constructor(
        private singleBetInputBuilder: SingleBetInputBuilder,
        private comboBetInputBuilder: ComboBetInputBuilder,
        private betslipConfig: BetslipConfig,
    ) {
        super();
    }

    getUpsellInput(betslipState: BetslipStateInput, bestSellingPick: BetslipPick): ICalculatorInput {
        const calculatorInput = this.getBaseCalculatorInput(betslipState);
        const pickInfo = {
            ...this.getPickInfo(bestSellingPick),
            eachWayInfo: null,
            isBanker: false,
            isXCast: isXCastPick(bestSellingPick),
            isStartingPrice: isStartingPriceSelected(bestSellingPick),
        };
        calculatorInput.betslip.forEach((b) => {
            b.system = new ComboSlipType();
            b.items.push(pickInfo);
        });

        return calculatorInput;
    }

    private getBaseCalculatorInput(betslipState: BetslipStateInput): ICalculatorInput {
        if (betslipState.types.base.currentSelectedType === null) {
            return { betslip: [] };
        }
        switch (betslipState.types.base.currentSelectedType) {
            case BetslipType.Single:
                // When single bet type is selected we generate multiple slips
                return { betslip: Array.from(this.singleBetInputBuilder.getBetGeneratorInput(betslipState)) };
            case BetslipType.Combo:
                // When combo bet type is selected we generate 1 slips
                return {
                    betslip: Array.from(
                        this.comboBetInputBuilder.getBetGeneratorInput(betslipState, {
                            isSportcastAsComboEnabled: this.betslipConfig.isSportcastAsComboEnabled,
                        }),
                    ),
                };
            default:
                throw new Error(`Not supported betslip type: ${betslipState.types.base.currentSelectedType}`);
        }
    }
}
